import { render } from "./GameItem.vue?vue&type=template&id=5f59999d&scoped=true"
import script from "./GameItem.vue?vue&type=script&lang=js"
export * from "./GameItem.vue?vue&type=script&lang=js"

import "./GameItem.vue?vue&type=style&index=0&id=5f59999d&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f59999d"]])

export default __exports__